<template>
  <div class="app-container">
    <p>מטופל/ת יקר/ה,</p>

<p>מוצרי הקנאביס הרפואי של Bcann הם מוצרי פרמיום המוגשים לך לראשונה בישראל בשקיפות מלאה.</p>

<p>המוצרים מיוצרים במפעלי קבוצת בזלת תחת תנאים מבוקרים ועמידה בתקנים מחמירים. חומרי הגלם נבחרים בקפידה להבטחת האיכות ולבטיחות ללא פשרות!</p>
<el-row align="middle">
  <el-col :md="{span:1,offset:20}" :sm="{span:1,offset:18}" :xs="{span:1,offset:15}">
    <el-button icon="el-icon-search" circle size="mini"></el-button>
  </el-col>
  <el-col :md="3" :sm="5" :xs="8">
    <el-input
          v-model="search"
          size="mini"
          placeholder="חפש אצווה"
          id="searchDirective"
          @change="makeSearch"
          />

  </el-col>

</el-row>
<el-row>
    <el-table v-loading="loading" :data="list" highlight-current-row style="width: 100%;color:#000;" border fit @sort-change="sortChange">
      <el-table-column label="מספר אצווה" align="center" prop="Batch" sortable="custom"  width="130px"/>
      <el-table-column label="דוח" align="center" sortable="custom" width="104px">
            <template slot-scope="scope">
                <el-button type="primary" size="small" icon="el-icon-view" @click="windowOpen(scope.row.QAFile)" style="background-color:#8dc63f;" v-if="true">צפייה</el-button>
            </template>
	    </el-table-column>
      <el-table-column label="Actual THC [%]" align="center" prop="THC" sortable="custom" width="100px"/>
        <el-table-column label="Actual CBD [%]" align="center" prop="CBD" sortable="custom" width="100px"/>
        <el-table-column label="מותג" align="center" prop="Brand" :formatter="firstLetterUppercase" sortable="custom" min-width="100px"/>
		<el-table-column label="המוצר" align="right" prop="Product" sortable="custom" min-width="130px"/>
		<el-table-column label="קטגוריה" align="right" prop="Category" sortable="custom"  width="170px"/>
		<el-table-column label="אופי" align="center" prop="Character" sortable="custom"  width="130px" />
        <el-table-column label="תפוגה" align="right" :formatter="dateFormat" prop="Expity" sortable="custom" width="100px"/>


    </el-table>
    <span id="scrollMsg">** לצפיה בטבלה במלואה, יש לגלולה שמאלה-ימינה **</span>
  </el-row>
    <el-row>
      <el-col :span="24" align="center">
        <el-pagination :total="total" layout="prev, pager, next" prev-text="הקודם" next-text="הבא" @current-change="callServiceList"/>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import util from '@/utils/util.js'
import labResultService from '@/service/labResultService.js'
import labResult from '@/domain/labResult.js'
import moment from 'moment';
/* eslint-disable */
export default {
  data() {
    return {
      loading: true,
      sort: 'id',
      order: 'desc',
      total: 0,
      item: null,
      list: [],
      Batch: '',
      Brand: '',
      Product: '',
      Category: '',
      Character: '',
      Expity: '',
      THC: '',
      CBD: '',
      QAFile: '',
      search:''
    };
  },
  methods: {
    makeSearch(event) {
      this.callServiceList(1);
    },
    sortChange(event) {
      this.sort = event.prop
      this.order = event.order == 'ascending' ? 'asc' : 'desc'
      this.callServiceList()
    },
   dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) { return ""; }
       return moment(date).format("YYYY-MM");
    },
    firstLetterUppercase(row,col){
      var value = row[col.property];
      if (!value) return ''
      value = value.toString().toLowerCase();
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    callServiceList(page=1) {
      this.loading = true
      let labResultsService = new labResultService(this)
      labResultsService.list(page, this.sort, this.order,{ 'searchFor': this.search }).then(list => {
        if (list) {
          this.total = list.data.total
          this.list = list.data.data
        }
        this.loading = false
      })
    },
    windowOpen(tar)
    {
      window.open('/storage/'+tar);
    }
  },

  created() {
    this.callServiceList()
  }
};
</script>
<style>
.confirmStyle{
  direction: rtl;
  text-align: right;
}
.el-message-box__status{
left:20px;
}
.el-message-box__btns{
  text-align: left;
}
.el-message-box__headerbtn{
  right:none;
  left:15px;

}
.el-form-item__label{
  float:right !important;
}
.el-dialog{
  width:95%  !important;
  margin-top: 1vh !important;
}
.el-row {
    margin-bottom: 20px;

 }
.el-dialog__title{
  font-weight: bolder;
  font-size:28px;
  text-align: center;
  margin: auto;
  display: block;
}
.el-button [class*=el-icon-]+span{
    margin-right:5px;
}
.app-container p{
  text-align: right;
  font-weight: normal;
  margin: 0 0 20px 0;
  color:#000;
}
#searchDirective{
  font-size:16px;
}
#searchDirective:focus{
  direction: ltr;

}
.el-table th, .el-table tr{
  background-color: transparent;
}
.el-table, .el-table__expanded-cell{
  background-color: transparent;
}
#scrollMsg{
  display: inline;
}
@media screen and (min-width: 1090px)
{
  #scrollMsg{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/labResults/index.vue